import React from "react";
import { connect } from "react-redux";
import { Activity } from 'lucide-react';

function ResponseTimeContainer({ value }) {
    return (
        <div className="oct_sys-chart-card-v2">
            <div className="oct_sys-chart-header-v2 mb-4">
                <Activity className="oct_icon" />
                <h3>Avg Response Time</h3>
            </div>

            <div className="oct_sys-response-time-wrapper-v2">
                <div className="text-center">
                    <div className="value">{value}</div>
                    <div className="unit">s</div>
                </div>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    const pageData = state.systemPage;
    return { value: pageData.avgResponse || '0.00' };
}

export default connect(mapStateToProps)(ResponseTimeContainer);